import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import AddLesson from "../../Templates/Lessons/AddLesson/AddLesson";
import { courseURL, lessonURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import useFetchWhen from "../../Hooks/useFetchWhen";

function AddLessonPage({ Edit = false }) {
  const { contextData } = useContext(userContext);
  const { id, lesson_id } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [lesson, setLesson] = useState(null);

  const { data, loading, error } = useFetch(`${courseURL}/${id}`);
  const {
    data: lessonData,
    loading: lessonLoading,
    error: lessonError,
  } = useFetchWhen(`${courseURL}/${id}/lessons/${lesson_id}`, Edit);

  useEffect(() => {
    if (!loading && !error && data) {
      setCourse(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!lessonLoading && !lessonError && lessonData) {
      setLesson(lessonData?.data);
    }
  }, [lessonData, lessonLoading, lessonError]);

  return (
    <AddLesson
      lesson={lesson}
      loading={loading}
      contextData={contextData}
      course={course}
      Edit={Edit}
      lessonLoading={lessonLoading}
    />
  );
}

export default AddLessonPage;
